<template>
  <div>
    <v-card flat outlined style="border: 3px solid #18CAE6; " class="ma-auto" light>
      <v-card-title class="ma-auto">
        <span class="headline">
          CLIENT
          <span class="red--text">FORM</span>
        </span>
        <v-spacer></v-spacer>
        <v-expand-transition>
          <div class="red--text">
            <span>{{ appMessage }}</span>
            <v-btn v-if="appMessage" @click="clearAppMessage" small text rounded outlined>close</v-btn>
          </div>
        </v-expand-transition>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-form class="ma-2 pa-2" @submit.prevent="onSaveForm" ref="form">
        <div>
          <v-card
            style="border-radius: 26px; border: 1px solid #a07800"
            outlined
            tile
            rounded
            class="ma-auto"
            dense
            light
          >
            <v-form @submit.prevent="onContinue">
              <v-container fluid v-if="!continueForm">
                <v-row>
                  <v-radio-group
                    v-model="type"
                    row
                    label="WHAT TYPE OF ENTITY ARE YOU"
                    class="ma-auto text-center"
                  >
                    <v-radio class="ma-auto" label="Individual" value="individual"></v-radio>
                    <v-radio class="ma-auto" label="Business" value="business"></v-radio>
                  </v-radio-group>
                </v-row>

                <v-expand-transition>
                  <div v-if="type == 'individual'">
                    <v-text-field
                      v-model="firstName"
                      label="FIRST NAME"
                      color="#a07800"
                      autofocus
                      style="max-width: 500px"
                      class="ma-auto"
                      clearable
                      outlined
                    ></v-text-field>
                    <v-text-field
                      v-model="lastName"
                      label="LAST NAME"
                      color="#a07800"
                      style="max-width: 500px"
                      class="ma-auto"
                      clearable
                      outlined
                    ></v-text-field>
                  </div>
                </v-expand-transition>
                <!-- -->
                <v-expand-transition>
                  <v-text-field
                    v-if="type == 'business'"
                    v-model="fullName"
                    label="FULL BUSINESS NAME"
                    color="#a07800"
                    autofocus
                    style="max-width: 500px"
                    class="ma-auto"
                    clearable
                    outlined
                  ></v-text-field>
                </v-expand-transition>
                <v-text-field
                  v-model="email"
                  label="EMAIL:"
                  color="#a07800"
                  style="max-width: 500px"
                  class="ma-auto"
                ></v-text-field>
                <v-text-field
                  v-model="phone"
                  label="PHONE NUMBER:"
                  color="#a07800"
                  style="max-width: 500px"
                  class="ma-auto"
                  hint="(###) ###-####"
                  v-mask="phoneMask"
                ></v-text-field>
                <div class="text-center">
                  <v-btn oulined rounded color="green" :disabled="!phone" type="submit">CONITNUE</v-btn>
                </div>
              </v-container>
            </v-form>

            <!-- <v-card color="black" class="ma-2" style="border-radius: 10px"> -->
            <div class="ma-3">
              <v-progress-circular
                class="text-center ma-auto"
                indeterminate
                size="64"
                v-if="overlay"
              ></v-progress-circular>

              <!-- <v-expand-transition> -->
              <div class="ma-auto" v-if="continueForm">
                <div v-if="preMadeForm">
                  <div v-if="preMadeFormQuestions">
                    <div v-if="formTitle">
                      <v-card-text light class="text-center headline ma-3">
                        {{
                        formTitle
                        }}
                      </v-card-text>
                    </div>
                    <div v-if="instructions" class="ma-3">
                      <v-expand-transition>
                        <div v-if="showInstructions">
                          <!-- <v-expand-transition> -->
                          <!-- <div> -->
                          <v-card-text
                            class="text-center headline red--text ma-3"
                            style="text-decoration: underline"
                          >INSTRUCTIONS</v-card-text>
                          <!-- </v-expand-transition> -->

                          <div
                            v-for="(inst, index) in instructions"
                            :key="index"
                            class="ma-3 text-justify"
                          >
                            <p class="title text-justify">{{ inst }}</p>
                            <!-- <p class="title text-justify font-weight-light">{{ inst }}</p> -->
                          </div>

                          <!-- </div> -->
                        </div>
                      </v-expand-transition>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          small
                          rounded
                          outlined
                          v-if="showInstructions"
                          @click="showInstructions = false"
                        >HIDE INSTRUCTIONS</v-btn>
                        <v-btn
                          small
                          rounded
                          outlined
                          v-if="!showInstructions"
                          @click="showInstructions = true"
                        >SHOW INSTRUCTIONS</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </div>
                    <v-card
                      style="border-radius: 26px; width: auto; border: 1px solid #a07800; min-height: 550px;"
                      light
                    >
                      <!-- <v-card
                      dark
                      style="background-color: black; border-radius: 26px; width: auto; border: 1px solid #a07800; min-height: 600px;"
                      >-->
                      <v-card-title
                        class="display-1 font-weight-regular justify-space-between text-center"
                      >
                        <!-- <span style="overflow-wrap: normal">{{ currentTitle }}</span> -->
                        <!-- <v-avatar
                          color="black"
                          class="subheading white--text font-weight-bold"
                          size="34"
                          v-text="windowStep"
                        ></v-avatar>-->
                        <v-spacer></v-spacer>
                        <div class="text-center">{{ windowStep }}/{{ windowSteps }}</div>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-card-actions>
                        <v-btn
                          :disabled="windowStep === 1"
                          dark
                          @click="windowStep--"
                          large
                          color="red"
                          rounded
                        >Back</v-btn>
                        <v-spacer></v-spacer>

                        <v-btn
                          :disabled="windowStep === windowSteps"
                          color="primary"
                          depressed
                          @click="saveAndContinue"
                          rounded
                          dark
                          large
                        >Next</v-btn>
                      </v-card-actions>
                      <hr
                        size="1px"
                        color="#18CAE6"
                        style="width: 75%"
                        class="ml-auto mr-auto mt-3 mb-3"
                      />
                      <v-window v-model="windowStep" style="overflow-x: scroll" continuous>
                        <div v-for="(q, i) in preMadeFormQuestions" :key="i">
                          <v-window-item :value="i + 1">
                            <v-card-text v-if="q.type === 'date'">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>

                              <!-- <v-textarea
                                label="Place Your Response Here"
                                v-model="q.response"
                                color="primary"
                                style="max-width: 700px;"
                                auto-grow
                                class="ma-2"
                                outlined
                                v-mask="dateMask"
                                hint="DD/MM/YYYY"
                                clearable
                              ></v-textarea>-->
                              <v-textarea
                                label="Place Your Response Here"
                                v-model="q.response"
                                color="primary"
                                style="max-width: 700px;"
                                auto-grow
                                class="ma-2"
                                outlined
                                hint="DD/MM/YYYY"
                                clearable
                              ></v-textarea>
                            </v-card-text>
                            <v-card-text v-if="q.type === 'address'" class="ma-auto">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>

                              <v-text-field
                                color="primary"
                                style="max-width: 500px"
                                class="ma-2"
                                outlined
                                label="Place Your Response Here"
                                v-model="q.response"
                                clearable
                              ></v-text-field>
                            </v-card-text>
                            <v-card-text v-if="q.type === 'textArea'">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>

                              <v-textarea
                                auto-grow
                                color="primary"
                                style="max-width: 700px"
                                class="ma-2"
                                outlined
                                label="Place Your Response Here"
                                v-model="q.response"
                                clearable
                              ></v-textarea>
                            </v-card-text>
                            <v-card-text v-if="q.type === 'listOfNames'">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>
                              <v-text-field
                                label="Place Your Response Here"
                                v-model="tempListItem"
                                color="primary"
                                style="max-width: 500px"
                                class="ma-2"
                                outlined
                                hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                clearable
                              ></v-text-field>
                              <v-layout>
                                <v-btn
                                  :disabled="!tempListItem"
                                  rounded
                                  color="green"
                                  @click="addResponseToList(i)"
                                >
                                  <v-icon>mdi-plus</v-icon>ADD
                                </v-btn>
                                <v-spacer></v-spacer>
                              </v-layout>

                              <v-layout column class="ma-2">
                                <div class="ma-2 text-center title">Current List</div>
                                <div
                                  class="ma-2 text-center subtitle-1"
                                  v-for="(r, index) in q.response"
                                  :key="index"
                                >
                                  {{ index + 1 }} - {{ r }}
                                  <v-btn
                                    class="ma-2"
                                    rounded
                                    outlined
                                    color="red"
                                    small
                                    @click="removeResponseFromList(i, index)"
                                  >remove</v-btn>
                                </div>
                              </v-layout>
                            </v-card-text>
                            <v-card-text v-if="q.type === 'dependantBoolTrue'">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>
                              <v-radio-group v-model="q.response">
                                <v-radio label="YES" value="true"></v-radio>
                                <v-radio
                                  label="NO"
                                  value="false"
                                  @click="clearDependantQuestionResponse(i)"
                                ></v-radio>
                              </v-radio-group>
                              <v-expand-transition>
                                <div v-if="q.response === 'true'">
                                  <div
                                    class="ma-4 title font-weight-regular"
                                  >{{ q.dependantQuestion.text }}</div>
                                  <div
                                    v-if="
                                      q.dependantQuestion.type === 'textArea'
                                    "
                                  >
                                    <v-textarea
                                      color="primary"
                                      style="max-width: 700px"
                                      auto-grow
                                      class="ma-2"
                                      outlined
                                      label="Place Your Response Here"
                                      v-model="q.dependantQuestion.response"
                                      clearable
                                    ></v-textarea>
                                  </div>
                                  <div
                                    v-if="
                                      q.dependantQuestion.type ===
                                        'subListOfNames'
                                    "
                                  >
                                    <v-text-field
                                      label="Place Your Response Here"
                                      v-model="tempListItem"
                                      color="primary"
                                      style="max-width: 500px"
                                      class="ma-2"
                                      outlined
                                      hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                      clearable
                                    ></v-text-field>
                                    <v-layout>
                                      <v-btn
                                        :disabled="!tempListItem"
                                        rounded
                                        color="green"
                                        @click="addResponseToList(i)"
                                      >
                                        <v-icon>mdi-plus</v-icon>ADD
                                      </v-btn>
                                      <v-spacer></v-spacer>
                                    </v-layout>

                                    <v-layout column class="ma-2">
                                      <div class="ma-2 text-center title">Current List</div>
                                      <div
                                        class="ma-2 text-center subtitle-1"
                                        v-for="(r, index) in q.dependantQuestion
                                          .response"
                                        :key="index"
                                      >
                                        {{ index + 1 }} - {{ r }}
                                        <v-btn
                                          class="ma-2"
                                          rounded
                                          outlined
                                          color="red"
                                          small
                                          @click="
                                            removeResponseFromList(i, index)
                                          "
                                        >remove</v-btn>
                                      </div>
                                    </v-layout>
                                  </div>
                                  <div
                                    v-if="
                                      q.dependantQuestion.type ===
                                        'optionsExclusiveBool'
                                    "
                                  >
                                    <v-radio-group v-model="q.dependantQuestion.response">
                                      <v-radio label="YES" value="true"></v-radio>
                                      <v-radio
                                        label="NO"
                                        value="false"
                                        @click="
                                          clearDependantSubQuestionResponse(i)
                                        "
                                      ></v-radio>
                                    </v-radio-group>
                                    <v-expand-transition>
                                      <div
                                        v-if="
                                          q.dependantQuestion.response ===
                                            'true'
                                        "
                                      >
                                        <v-radio-group
                                          v-model="
                                            q.dependantQuestion.optionResponse
                                          "
                                        >
                                          <div
                                            v-for="(option, index) in q
                                              .dependantQuestion.options"
                                            :key="index"
                                          >
                                            <v-radio :label="option" :value="option"></v-radio>
                                          </div>
                                        </v-radio-group>
                                        <div
                                          v-if="
                                            q.dependantQuestion
                                              .subDependantQuestion
                                          "
                                        >
                                          <div class="ma-4 title font-weight-regular">
                                            {{
                                            q.dependantQuestion
                                            .subDependantQuestion.text
                                            }}
                                          </div>
                                          <div
                                            v-if="
                                              q.dependantQuestion
                                                .subDependantQuestion.type ===
                                                'subListOfNames'
                                            "
                                          >
                                            <v-text-field
                                              label="Place Your Response Here"
                                              v-model="tempListItem"
                                              color="primary"
                                              style="max-width: 500px"
                                              class="ma-2"
                                              outlined
                                              hint="CLICK THE ADD BUTTON TO ADD TO LIST"
                                              clearable
                                            ></v-text-field>
                                            <v-layout>
                                              <v-btn
                                                :disabled="!tempListItem"
                                                rounded
                                                color="green"
                                                @click="
                                                  addSubDependantResponseToList(
                                                    i
                                                  )
                                                "
                                              >
                                                <v-icon>mdi-plus</v-icon>ADD
                                              </v-btn>
                                              <v-spacer></v-spacer>
                                            </v-layout>

                                            <v-layout column class="ma-2">
                                              <div class="ma-2 text-center title">Current List</div>
                                              <div
                                                class="ma-2 text-center subtitle-1"
                                                v-for="(r, index) in q
                                                  .dependantQuestion
                                                  .subDependantQuestion
                                                  .response"
                                                :key="index"
                                              >
                                                {{ index + 1 }} - {{ r }}
                                                <v-btn
                                                  class="ma-2"
                                                  rounded
                                                  outlined
                                                  color="red"
                                                  small
                                                  @click="
                                                    removeSubDependantResponseFromList(
                                                      i,
                                                      index
                                                    )
                                                  "
                                                >remove</v-btn>
                                              </div>
                                            </v-layout>
                                          </div>
                                        </div>
                                      </div>
                                    </v-expand-transition>
                                  </div>
                                </div>
                              </v-expand-transition>
                            </v-card-text>
                            <v-card-text v-if="q.type === 'boolDependantSetMultipleAnswer'">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>
                              <v-radio-group v-model="q.response">
                                <v-radio label="YES" value="true"></v-radio>
                                <v-radio
                                  label="NO"
                                  value="false"
                                  @click="clearDependantSetResponse(i)"
                                ></v-radio>
                              </v-radio-group>
                              <div v-if="q.response === 'true'">
                                <div v-for="(dq, index) in q.dependantSet" :key="index">
                                  <div class="ma-4 title font-weight-regular">{{ dq.text }}</div>
                                  <div v-if="dq.type === 'textArea'">
                                    <v-textarea
                                      color="primary"
                                      style="max-width: 700px"
                                      class="ma-2"
                                      outlined
                                      label="Place Your Response Here"
                                      v-model="tempSetResponses[`${dq.model}`]"
                                      clearable
                                      auto-grow
                                    ></v-textarea>
                                  </div>

                                  <div v-if="dq.type === 'textField'">
                                    <v-text-field
                                      color="primary"
                                      style="max-width: 500px"
                                      class="ma-2"
                                      outlined
                                      label="Place Your Response Here"
                                      v-model="tempSetResponses[`${dq.model}`]"
                                      clearable
                                    ></v-text-field>
                                  </div>
                                  <div v-if="dq.type === 'boolDependantSet'">
                                    <v-radio-group v-model="tempSetResponses[`${dq.model}`]">
                                      <v-radio label="YES" value="true"></v-radio>
                                      <v-radio
                                        label="NO"
                                        value="false"
                                        @click="
                                          clearSubDependantSetResponse(i, index)
                                        "
                                      ></v-radio>
                                    </v-radio-group>
                                    <div
                                      v-if="
                                        tempSetResponses[`${dq.model}`] ===
                                          'true'
                                      "
                                    >
                                      <div
                                        v-for="(subDQ,
                                        index) in dq.dependantSet"
                                        :key="index"
                                      >
                                        <div class="ma-4 title font-weight-regular">{{ subDQ.text }}</div>
                                        <div v-if="subDQ.type === 'textArea'">
                                          <v-textarea
                                            color="primary"
                                            style="max-width: 700px"
                                            class="ma-2"
                                            outlined
                                            label="Place Your Response Here"
                                            v-model="
                                              tempSetResponses[`${subDQ.model}`]
                                            "
                                            clearable
                                            auto-grow
                                          ></v-textarea>
                                        </div>
                                        <div v-if="subDQ.type === 'textField'">
                                          <v-text-field
                                            color="primary"
                                            style="max-width: 500px"
                                            class="ma-2"
                                            outlined
                                            label="Place Your Response Here"
                                            v-model="
                                              tempSetResponses[`${subDQ.model}`]
                                            "
                                            clearable
                                          ></v-text-field>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <v-btn @click="addDependantSetResponse(i)" color="green" rounded>ADD</v-btn>
                              <v-layout column class="ma-2">
                                <div class="ma-2 text-center title">Current List</div>
                                <div
                                  class="ma-2 text-center subtitle-1"
                                  v-for="(r, index) in preMadeFormQuestions[i]
                                    .setResponses"
                                  :key="index"
                                >
                                  {{ index + 1 }} - {{ r }}
                                  <v-btn
                                    class="ma-2"
                                    rounded
                                    outlined
                                    color="red"
                                    small
                                    @click="removeSetResponse(i, index)"
                                  >remove</v-btn>
                                </div>
                              </v-layout>
                            </v-card-text>
                            <v-card-text v-if="q.type === 'boolDependantSet'">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>
                              <v-radio-group v-model="q.response">
                                <v-radio label="YES" value="true"></v-radio>
                                <v-radio
                                  label="NO"
                                  value="false"
                                  @click="clearDependantSetResponse(i)"
                                ></v-radio>
                              </v-radio-group>
                              <div v-if="q.response === 'true'">
                                <div v-for="(dq, index) in q.dependantSet" :key="index">
                                  <div class="ma-4 title font-weight-regular">{{ dq.text }}</div>
                                  <div v-if="dq.type === 'textArea'">
                                    <v-textarea
                                      color="primary"
                                      style="max-width: 700px"
                                      class="ma-2"
                                      outlined
                                      label="Place Your Response Here"
                                      v-model="dq.response"
                                      clearable
                                      auto-grow
                                    ></v-textarea>
                                  </div>

                                  <div v-if="dq.type === 'textField'">
                                    <v-text-field
                                      color="primary"
                                      style="max-width: 500px"
                                      class="ma-2"
                                      outlined
                                      label="Place Your Response Here"
                                      v-model="dq.response"
                                      clearable
                                    ></v-text-field>
                                  </div>
                                  <div v-if="dq.type === 'boolDependantSet'">
                                    <v-radio-group v-model="dq.response">
                                      <v-radio label="YES" value="true"></v-radio>
                                      <v-radio
                                        label="NO"
                                        value="false"
                                        @click="
                                          clearSubDependantSetResponse(i, index)
                                        "
                                      ></v-radio>
                                    </v-radio-group>
                                    <div v-if="dq.response === 'true'">
                                      <div
                                        v-for="(subDQ,
                                        index) in dq.dependantSet"
                                        :key="index"
                                      >
                                        <div class="ma-4 title font-weight-regular">{{ subDQ.text }}</div>
                                        <div v-if="subDQ.type === 'textArea'">
                                          <v-textarea
                                            color="primary"
                                            style="max-width: 700px"
                                            class="ma-2"
                                            outlined
                                            label="Place Your Response Here"
                                            v-model="subDQ.response"
                                            clearable
                                            auto-grow
                                          ></v-textarea>
                                        </div>
                                        <div v-if="subDQ.type === 'textField'">
                                          <v-text-field
                                            color="primary"
                                            style="max-width: 500px"
                                            class="ma-2"
                                            outlined
                                            label="Place Your Response Here"
                                            v-model="subDQ.response"
                                            clearable
                                          ></v-text-field>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-card-text>
                            <v-card-text v-if="q.type === 'clientSignature'">
                              <div class="ma-4 title font-weight-regular">{{ q.text }}</div>
                              <div class="text-center">
                                <v-btn
                                  class="ma-auto"
                                  v-if="!autoSign"
                                  large
                                  @click="toggleAutoSign"
                                >TYPE YOUR SIGNATURE</v-btn>
                                <v-btn
                                  class="ma-auto"
                                  v-if="autoSign"
                                  large
                                  @click="toggleAutoSign"
                                >SIGN WITH BOX</v-btn>
                              </div>
                              <div v-if="!autoSign">
                                <v-expand-transition>
                                  <VueSignaturePad
                                    width="500px"
                                    height="200px"
                                    ref="signaturePad"
                                    style="border: 1px solid blue; background-color: white"
                                    class="ma-auto"
                                  />
                                </v-expand-transition>
                              </div>
                              <v-expand-transition>
                                <div v-if="autoSign" class="text-center ma-auto">
                                  <div class="text-center">
                                    <v-layout row>
                                      <v-spacer></v-spacer>
                                      <v-text-field
                                        color="primary"
                                        style="max-width: 500px"
                                        outlined
                                        label="Type Your Name"
                                        v-model="textSignature"
                                        clearable
                                        class="ma-auto"
                                      ></v-text-field>
                                      <v-btn large @click="saveTextSignature(i)">ACCEPT</v-btn>
                                      <v-spacer></v-spacer>
                                    </v-layout>
                                  </div>
                                </div>
                              </v-expand-transition>
                              <div class="text-center">
                                <v-btn @click="undo" :disabled="autoSign">Undo</v-btn>
                                <v-btn @click="save(i)" :disabled="autoSign">Save Signature</v-btn>
                              </div>
                              <v-btn
                                v-if="!autoSign"
                                :disabled="!signature"
                                large
                                rounded
                                color="green"
                                @click="onSaveFormResponses"
                              >Save Responses</v-btn>
                              <v-btn
                                v-if="autoSign"
                                :disabled="!textSignature"
                                large
                                rounded
                                color="green"
                                @click="onSaveFormResponses"
                              >Save Responses</v-btn>
                              <div
                                v-if="lastResponse"
                                class="text-center"
                              >LAST RESPONSE: {{ lastResponse }}</div>
                            </v-card-text>
                          </v-window-item>
                        </div>
                      </v-window>
                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-btn
                          :disabled="windowStep === 1"
                          dark
                          @click="windowStep--"
                          large
                          color="red"
                          rounded
                        >Back</v-btn>
                        <v-spacer></v-spacer>

                        <v-btn
                          :disabled="windowStep === windowSteps"
                          color="primary"
                          depressed
                          @click="saveAndContinue"
                          rounded
                          dark
                          large
                        >Next</v-btn>
                      </v-card-actions>
                      <hr
                        size="1px"
                        color="#18CAE6"
                        style="width: 75%"
                        class="ml-auto mr-auto mt-3 mb-3"
                      />
                      <!-- <div class="ma-2 title font-weight-regular text-center"> -->
                      <div class="ma-2">
                        <div
                          class="title font-weight-regular text-center"
                          v-if="!showDocs"
                          @click="showDocs = true"
                        >
                          click here to upload documents
                          <!-- <v-icon
                            @click="showDocs = true"
                            v-if="!showDocs"
                          >mdi-arrow-down-bold-circle-outline</v-icon>-->
                        </div>
                        <div
                          class="title font-weight-regular text-center"
                          v-if="showDocs"
                          @click="showDocs = false"
                        >
                          click here to hide documents
                          <!-- <v-icon
                            @click="showDocs = false"
                            v-if="showDocs"
                          >mdi-arrow-up-bold-circle-outline</v-icon>-->
                        </div>
                      </div>

                      <hr
                        size="1px"
                        color="#18CAE6"
                        style="width: 75%"
                        class="ml-auto mr-auto mt-3 mb-3"
                      />
                      <v-expand-transition v-if="showDocs">
                        <v-layout row>
                          <div style="width: 45%">
                            <div v-for="(category, index) in documentCategories" :key="index">
                              <template>
                                <div>
                                  <app-doc-uploader-dialog
                                    :category="category"
                                    :firm_slug="firmSlug"
                                    :matter_slug="matterSlug"
                                    :client_slug="clientSlug"
                                  ></app-doc-uploader-dialog>
                                </div>
                              </template>
                            </div>
                          </div>
                          <v-divider vertical></v-divider>
                          <div style="width: 50%">
                            <div v-for="(doc, i) in user.clientDocs" :key="i">
                              <div class="ma-2">
                                {{ doc.name }} -
                                <span
                                  v-if="doc.category === 'personalInformation'"
                                  class="ma-4 font-weight-regular text-center"
                                >CATEGORY: PERSONAL</span>
                                <span
                                  v-if="doc.category === 'generalInformation'"
                                  class="ma-4 font-weight-regular text-center"
                                >CATEGORY: GENERAL</span>
                                <span
                                  v-if="doc.category === 'damages'"
                                  class="ma-4 font-weight-regular text-center"
                                >CATEGORY: DAMAGES</span>
                                <span
                                  v-if="doc.category === 'miscellaneous'"
                                  class="ma-4 font-weight-regular text-center"
                                >CATEGORY: MISCELLANEOUS</span>
                              </div>
                              <v-btn
                                rounded
                                outlined
                                color="red"
                                small
                                @click="removeClientDocument(doc, i)"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </div>
                          </div>
                        </v-layout>
                      </v-expand-transition>
                    </v-card>
                  </div>
                </div>

                <v-card-actions>
                  <v-btn
                    v-if="!autoSign"
                    :disabled="!signature"
                    large
                    rounded
                    color="green"
                    @click="onSaveFormResponses"
                  >Save Responses</v-btn>
                  <v-btn
                    v-if="autoSign"
                    :disabled="!textSignature"
                    large
                    rounded
                    color="green"
                    @click="onSaveFormResponses"
                  >Save Responses</v-btn>
                  <div v-if="lastResponse" class="text-center">LAST RESPONSE: {{ lastResponse }}</div>
                  <!-- <v-btn
                    :disabled="!signature"
                    large
                    outlined
                    style="background-color: black"
                    rounded
                    color="green"
                    dark
                    @click="onSaveFormResponses"
                  >Save Responses</v-btn>-->
                </v-card-actions>

                <!-- <div v-if="user.formDef.questions.length">
                  {{ user.formDef.questions }}
                </div>-->
              </div>
              <!-- </v-expand-transition> -->
            </div>
          </v-card>
        </div>
        <v-layout row class="mt-2">
          <!-- <v-btn rounded color="green" dark type="submit">SUBMIT</v-btn> -->
          <!-- <v-btn rounded color="green" dark @click="logQuestions">logQs</v-btn> -->
          <v-spacer></v-spacer>
        </v-layout>
      </v-form>
    </v-card>
  </div>
</template>

<script>
/**
 * this component is no longer beng used for newer "clients"
 * the component ClientForm is the current version
 * the only reason this component is still here is because
 * there were older clients that still needed to access their forms and fill them out
 * and since I made some breaking changes to the client object in the database
 * I had to keep this old component untill they fill out their forms
 * This component will not be needed once the database is cleared of older client objects
 */

import { mask } from "vue-the-mask";
import slugify from "slugify";
import * as firebase from "firebase";
import * as moment from "moment";
import VueSignaturePad from "vue-signature-pad";

export default {
  directives: {
    mask,
  },
  name: "PartyForm",
  components: {
    VueSignaturePad,
  },
  // props: ["matter", "user"],
  data() {
    return {
      // message: null,
      lastResponse: null,
      textSignature: null,
      autoSign: false,
      overlay: false,
      showDocs: false,
      dialog: false,
      signature: null,
      e1: 0,
      windowStep: 1,
      firstName: null,
      lastName: null,
      fullName: null,
      email: null,
      phone: null,
      phoneMask: "(###) ###-####",
      dateMask: "##/##/####",
      // continueForm: false,
      minor: false,
      guardian: null,
      message: null,
      info: null,
      type: null,
      alias: null,
      personal: null,
      capacity: null,
      insured: null,
      treated: false,
      injuries: [],
      owner: null,
      rent: null,
      //general background
      presentAddress: {
        addressLine1: null,
        city: null,
        state: null,
        zip: null,
      },
      employer: {
        name: null,
        addressLine1: null,
        city: null,
        state: null,
        zip: null,
        duties: null,
        jobTitle: null,
      },
      ownerOfRealProperty: false,
      renter: false,
      businessOwner: false,
      //insurance
      insurance: {
        insured: false,
        insurerName: null,
        policyNumber: null,
        policyLimit: null,
      },
      //property Damage
      property: {
        addressLine1: null,
        city: null,
        state: null,
        zip: null,
        damages: [],
      },
      incomeLoss: [],
      preMadeFormQuestions: null,
      instructions: null,
      formTitle: null,
      windowSteps: null,
      showInstructions: false,
      tempListItem: null,
      tempArray: null,
      tempSetResponses: {},
      documentCategories: null,
      reloaded: false,
    };
  },
  computed: {
    appMessage() {
      return this.$store.getters.appMessage;
    },
    clientSlug() {
      return this.$route.params.id;
    },
    firmSlug() {
      return this.$route.params.firm;
    },
    matterSlug() {
      return this.$route.params.matter;
    },
    user() {
      return this.$store.getters.user;
    },
    firm() {
      return this.$store.getters.firm;
    },
    questions() {
      return this.user.formDef.questions;
    },
    preMadeForm() {
      return this.user.formDef.preMadeForm;
    },
    role() {
      return this.$store.getters.role;
    },
    continueForm() {
      if (this.user && this.role === "client") {
        return true;
      } else {
        return false;
      }
    },
    steps() {
      // return this.user.stepCount;
      return this.user.formDef.questions.length;
    },
    currentTitle() {
      switch (this.windowStep) {
        // this.windowStep.forEach(step =>{
        case this.windowStep:
          return this.preMadeFormQuestions[this.windowStep - 1].text;
        // })

        // case 2: return 'Create a password'
        default:
          return "Done";
      }
    },
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    },
    personal(val) {
      if (val === "yes") {
        this.capacity = "in his/her personal capacity";
      }
    },
    insured(val) {
      if (val === "true") {
        this.insurance.insured = true;
      }
    },
    owner(val) {
      if (val === "true") {
        this.ownerOfRealProperty = true;
      }
    },
    type(val) {
      if (val == "business") {
        this.businessOwner = true;
      }
    },
    rent(val) {
      if (val == "true") {
        this.renter = true;
      }
    },
    capacity(val) {
      if (val == "as guardian ad litem") {
        this.minor = true;
      }
    },
    user(val) {
      console.log("user from watch", val);
      const getPreMadeForm = firebase
        .functions()
        .httpsCallable("getPreMadeForm");
      //this should get the preMadeForm that is specified in the route by the index number in the route
      // if there are no responses
      if (!this.user.formDef.responses) {
        this.overlay = true;
        getPreMadeForm({
          user: this.user,
          matterSlug: this.$route.params.matter,
          firmSlug: this.$route.params.firm,
          clientSlug: this.$route.params.id,
          //this should request the index of the preMadeForm that the route has in it
          preMadeForm: this.user.formDef.preMadeForm,
          // type: this.user.partyType,
          type: this.type,
          hasResponded: false,
        }).then((res) => {
          console.log("res.data", res.data);
          if (res.data === null) {
            console.log("reload this muther fucker");
            document.location.reload();
          }
          // this.preMadeFormQuestions = res.data.questions;

          //experimental the above was working but i want to be able to save every step,
          //now "getPreMadeForm" gets the questions and saves them as answers, the user object
          //now has the questions as answers and everytime the next button is clicked the old responses will be replaced by the new responses
          this.preMadeFormQuestions = this.user.formDef.responses;
          // this.instructions = res.data.instructions;
          this.instructions = this.user.formDef.instructions;
          // this.formTitle = res.data.formTitle;
          this.formTitle = this.user.formDef.formTitle;
          // this.windowSteps = res.data.windowSteps;
          this.windowSteps = this.user.formDef.windowSteps;
          // this.lastResponse = this.user.formDef.responseDate;

          //experimental
          this.documentCategories = this.user.formDef.documentCategories;
          // this.preMadeFormQuestions
          this.overlay = false;
        });
      } else if (this.user.formDef.responses) {
        this.overlay = true;
        getPreMadeForm({
          user: this.user,
          matterSlug: this.$route.params.matter,
          firmSlug: this.$route.params.firm,
          clientSlug: this.$route.params.id,
          preMadeForm: this.user.formDef.preMadeForm,
          type: this.user.partyType,
          hasResponded: true,
        }).then((res) => {
          console.log("res.data", res.data);
          //  if(res.data === null){
          //   console.log("reload this muther fucker");
          // }
          // this.preMadeFormQuestions = res.data.questions;

          //experimental the above was working but i want to be able to save every step,
          //now "getPreMadeForm" gets the questions and saves them as answers, the user object
          //now has the questions as answers and everytime the next button is clicked the old responses will be replaced by the new responses
          this.preMadeFormQuestions = this.user.formDef.responses;
          this.instructions = this.user.formDef.instructions;
          this.formTitle = this.user.formDefformTitle;
          this.windowSteps = this.user.formDef.windowSteps;
          this.documentCategories = res.data.documentCategories;
          this.overlay = false;
          this.lastResponse = this.user.formDef.responseDate;
          //experimental
        });
      }
    },
  },
  methods: {
    clearAppMessage() {
      this.$store.dispatch("setAppMessage", null);
    },
    toggleAutoSign() {
      this.textSignature = null;
      this.autoSign = !this.autoSign;
    },
    saveAndContinue() {
      this.lastResponse = moment().format("MMMM Do YYYY, h:mm:ss a");
      firebase
        .firestore()
        .collection("firms")
        .doc(this.$route.params.firm)
        .collection("matters")
        .doc(this.$route.params.matter)
        .collection("clients")
        .doc(this.$route.params.id)

        //experimental
        .update({
          "formDef.responses": this.preMadeFormQuestions,
          "formDef.responseDate": moment().format("MMMM Do YYYY, h:mm:ss a"),
        })
        .then(() => {
          this.windowStep++;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    logType() {
      console.log(this.type);
      console.log("user", this.user);
      console.log("responselist", this.preMadeFormQuestions);
    },
    removeResponseFromList(i, index) {
      console.log(i);
      if (this.preMadeFormQuestions[i].dependantQuestion) {
        this.preMadeFormQuestions[i].dependantQuestion.response.splice(
          index,
          1
        );
      } else {
        this.preMadeFormQuestions[i].response.splice(index, 1);
      }
      // this.preMadeFormQuestions[i].response.splice(index, 1);
      // console.log(this.preMadeFormQuestions);
    },
    addResponseToList(i) {
      if (this.preMadeFormQuestions[i].dependantQuestion) {
        this.preMadeFormQuestions[i].dependantQuestion.response.push(
          this.tempListItem
        );
        this.tempListItem = null;
      } else {
        this.preMadeFormQuestions[i].response.push(this.tempListItem);
        this.tempListItem = null;
      }
      // this.preMadeFormQuestions[i].response.push(this.tempListItem);
      // this.tempListItem = null;
      console.log("responselist", this.preMadeFormQuestions);
      console.log("tempListItem", this.tempListItem);
    },
    addSubDependantResponseToList(i) {
      this.preMadeFormQuestions[
        i
      ].dependantQuestion.subDependantQuestion.response.push(this.tempListItem);
      this.tempListItem = null;
    },
    addDependantSetResponse(i) {
      this.preMadeFormQuestions[i].setResponses.push(this.tempSetResponses);
      console.log("responses", this.preMadeFormQuestions);
      // console.log(this.tempSetResponses);
      this.tempSetResponses = {};
      window.scrollTo({
        top: 100,
        left: 100,
        behavior: "smooth",
      });
    },
    removeSubDependantResponseFromList(i, index) {
      this.preMadeFormQuestions[
        i
      ].dependantQuestion.subDependantQuestion.response.splice(index, 1);
    },
    clearDependantQuestionResponse(i) {
      this.preMadeFormQuestions[i].response = "false";
      this.preMadeFormQuestions[i].dependantQuestion.response = [];
    },
    clearDependantSetResponse(i) {
      this.preMadeFormQuestions[i].response = "false";
      // this.preMadeFormQuestions[i].dependantSet.forEach(q => {
      //   q.response = null;
      // });
    },
    clearSubDependantSetResponse(i, index) {
      this.preMadeFormQuestions[i].dependantSet[index].response = "false";
    },
    clearDependantSubQuestionResponse(i) {
      this.preMadeFormQuestions[i].dependantQuestion.response = "false";
      this.preMadeFormQuestions[
        i
      ].dependantQuestion.subDependantQuestion.response = [];
    },
    removeSetResponse(i, index) {
      this.preMadeFormQuestions[i].setResponses.splice(index, 1);
    },

    addToDialogResponse(i) {
      let value = { ...this.preMadeFormQuestions[i].dialogQuestions };
      this.preMadeFormQuestions[i].response.push(value);
      // this.dialogDepQ = [];
    },
    logResponses() {
      console.log("from log responses", this.preMadeFormQuestions);
    },
    undo() {
      this.$refs.signaturePad[0].undoSignature();
    },
    save(i) {
      // const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(this.$refs);

      if (!this.autoSign) {
        const { isEmpty, data } = this.$refs.signaturePad[0].saveSignature();
        if (!isEmpty) {
          this.signature = data;
          if (this.user.formDef.preMadeForm) {
            this.preMadeFormQuestions[i].response = data;
          }
        }
      }
    },
    saveTextSignature(i) {
      if (this.textSignature !== null && this.textSignature !== undefined) {
        this.preMadeFormQuestions[i].response = {
          signature: this.textSignature,
        };
      } else {
        alert("YOU MUST EITHER SIGN OR TYPE YOUR SIGNATURE");
      }
    },
    nextStep(n) {
      console.log("n from next step", n);
      console.log("e1 from data", this.e1);
      let stepCount = parseInt(this.user.stepCount);
      if (n === stepCount) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    logQuestions() {
      console.log(this.questions);
      console.log(this.continueForm);
    },
    onSaveFormResponses() {
      firebase
        .firestore()
        .collection("firms")
        .doc(this.$route.params.firm)
        .collection("matters")
        .doc(this.$route.params.matter)
        .collection("clients")
        .doc(this.$route.params.id)
        // .update({
        //   "formResponses.preMadeFormResponses": firebase.firestore.FieldValue.arrayUnion({
        //     responseDate: moment().format("MMMM Do YYYY, h:mm:ss a"),
        //     title: this.user.formDef.preMadeForm,
        //     responses: this.preMadeFormQuestions
        //   })

        //experimental
        //experimental
        .update({
          "formDef.responses": this.preMadeFormQuestions,
          "formDef.responseDate": moment().format("MMMM Do YYYY, h:mm:ss a"),
          "formResponses.preMadeFormResponses": firebase.firestore.FieldValue.arrayUnion(
            {
              responseDate: moment().format("MMMM Do YYYY, h:mm:ss a"),
              message: `${this.user.fullName} has responded to ${this.user.formDef.preMadeForm}`,
              title: this.user.formDef.preMadeForm,
            }
          ),
        })
        .catch((err) => {
          console.log(err);
        });
    },
    removeClientDocument(doc, i) {
      console.log("removing this document", doc);
      console.log("document index", i);
      firebase
        .firestore()
        .collection("firms")
        .doc(this.$route.params.firm)
        .collection("matters")
        .doc(this.$route.params.matter)
        .collection("clients")
        .doc(this.$route.params.id)
        .update({
          clientDocs: firebase.firestore.FieldValue.arrayRemove(doc),
        })
        .then(() => {
          let ref = firebase
            .storage()
            .ref(`${this.$route.path}/${doc.category}/${doc.name}`);
          ref
            .delete()
            .then(() => {
              // this.user.clientDocs.splice(1, i)
              let payload = {
                firm: this.$route.params.firm,
                matter: this.$route.params.matter,
                client: this.$route.params.id,
              };
              this.$store.dispatch("autoLoginClient", payload);
            })
            .catch((e) => console.log(e));
        })
        .catch((e) => console.log(e));
    },
    onContinue() {
      //if individual
      // let alias = ``;
      if (this.type == "individual") {
        this.alias =
          this.firstName.trim() + " " + this.lastName.trim() + " " + this.phone;
      } else if (this.type == "business") {
        this.alias = this.fullName.trim() + " " + this.phone;
      }
      if (this.fullName == null) {
        this.fullName = this.firstName + " " + this.lastName;
      }
      //if business

      let partySlug = slugify(this.alias, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true,
      });
      console.log(
        "partySlug from PartyForm inside onContinue function",
        partySlug
      );
      // console.log(this.$route);
      // firebase.auth().signInWithEmailAndPassword(this.email, this.phone);
      this.$store.dispatch("signUserIn", {
        email: this.email,
        password: this.phone,
        firm: this.$route.params.firm,
        matter: this.$route.params.matter,
        client: this.$route.params.id,
        insurance: this.insurance,
        property: this.property,
        partyType: this.type,
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        fullName: this.fullName,
      });
    },
    onSaveForm() {
      console.log(this.info);
    },
  },
  created() {
    console.log("this.$route.params", this.$route.params);
    console.log("this.$route.path", this.$route.path);
    console.log("this.$route", this.$route);
    console.log("url", window.location.href);
    console.log(
      "from created at partyform this is preMadeForm",
      this.user.formDef.preMadeForm
    );
    console.log("firm:", this.firm);
  },
};
</script>

<style lang="scss" scoped></style>
